import { Navigate, Route, Routes } from 'react-router-dom';
import { Admin } from './pages/Admin';
import { Board } from './pages/Board';

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Board />} />
      <Route path="/admin" element={<Admin />} />
      {/* Anything else is a mistyped link; the board is the useful landing. */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
